import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { BreadcrumbService } from '@gfe/shared/breadcrumb/breadcrumb.service';

import { ICONS } from '@core/services/icons/icons.service';

import { BreadcrumbItemComponent } from './breadcrumb-item/breadcrumb-item.component';

@Component({
  selector: 'app-breadcrumb',
  imports: [BreadcrumbItemComponent],
  templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent {
  protected readonly breadcrumbItems = toSignal(
    inject(BreadcrumbService).getBreadcrumbs(),
    {
      initialValue: []
    }
  );

  protected readonly ICONS = ICONS;
}
